import React, { useEffect } from "react";
import "./HerbalInfusionsModal.css";
import tile5 from "../assets/tile5.png";

const HerbalInfusionsModal = ({ isOpen, onClose }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="hi-overlay" onClick={onClose}>
      <div className="hi-container" onClick={(e) => e.stopPropagation()}>
        <button className="hi-close" onClick={onClose}>&times;</button>

        <div className="hi-content">
          {/* Left — Image */}
          <div className="hi-image">
            <img
              src={tile5}
              alt="Herbal Infusions Through the Lens of Science"
            />
          </div>

          {/* Right — Text */}
          <div className="hi-text">
            <h1>HERBAL INFUSIONS THROUGH THE LENS OF SCIENCE</h1>

            <p>
              Unlike conventional teas, tisanes are rich in diverse bioactive compounds
              that interact with the body far beyond taste.
            </p>

            <h2>More Than a Brew</h2>
            <p>
              Modern science now confirms what ancient wisdom long understood: tisanes
              influence digestion, stress response, inflammation, and cellular balance.
              Their polyphenols, flavonoids, and essential plant compounds work quietly —
              supporting gut function, calming the nervous system, strengthening antioxidant
              defenses, and nurturing immune resilience.
            </p>

            <h2>Why They Matter Today?</h2>
            <p>
              In a world shaped by chronic stress, inflammation, and metabolic strain,
              tisanes offer something rare: support without suppression. They work in
              harmony with the body's natural rhythms, helping restore balance gently
              and effectively.
            </p>

            <h2>What's the Difference?</h2>
            <p>
              At RASAI NUTRIE, tisanes are functional formulations — not casual blends.
              Each ingredient is purposefully chosen for its physiological role. Free from
              synthetic additives, our blends are guided by science, crafted for daily use,
              and designed to work gently with the body.
            </p>

            <blockquote className="hi-quote">
              "Every cup is more than a moment of calm — it's where traditional herbal
              wisdom meets modern nutritional science."
            </blockquote>

            <button className="hi-back-btn" onClick={onClose}>Back to Home</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HerbalInfusionsModal;
